// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3Uz6V","filesListContainer":"PosDisputesFiles_filesListContainer__Ht2qh","filesButton":"PosDisputesFiles_filesButton__aGvhE"};